
import React from 'react';
import { get_filtered_shoutouts, show_codecommit_stats, get_tvmode_queue, update_queue,
  pick_winner, add_to_alert_queue, pop_from_alert_queue, add_to_new_shoutouts, pop_from_new_shoutouts, leave_pick_winner_mode,
  modal_next, modal_back, time_frame_tv_filter_toggled, recipient_tv_filter_toggled, code_input_changed, display_type_changed,
  set_time_frame_range, set_selected_users, clear_modal, connect_to_tv
} from '../actions/types';
import TVSlide from '../screens/tv/TVSlide';
import TVIntegrationSlide from '../screens/tv/TVIntegrationSlide';


const INITIAL_STATE = {
  timeFrame: '',
  users: [],
  filteredShoutouts: [],
  shoutouts: [],
  showWinnerButton: false,
  timeFrameSelected: false,
  recipientSelected: false,
  modalStep: 0,
  showStats: false,
  queue: [],
  alert: [],
  newShoutouts: [],
  codeText: '',
  displayType: 'onDevice',
  connection: ''
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case get_filtered_shoutouts: {
      let shoutouts = action.payload.shoutouts;
      let users = action.payload.users;
      let timeFrame = action.payload.timeFrame;
      let today = new Date();
      let range = 0;
      let showWinnerButton = false;

      switch (timeFrame) {
        // values found using date.getTime() and subtracting whole days/weeks/months
        case 'month': range = 2595600000; break;
        case 'week': range = 604800000; break;
        case 'today': range = 86400000; break;
        default: range = 0;
      }

      if (range !== 0) {
        shoutouts = shoutouts.filter((shoutout) => {
          let sent = new Date(shoutout.date);
          if (today.getTime() - sent.getTime() < range) return true;
          return false;
        });
      }
      if (!users || users.length === 0) showWinnerButton = true;

      let userFilteredShoutouts = shoutouts;
      // filter based on recipient
      if (users && users.length && users !== undefined) {
        let ids = users.map((user) => user._id);
        userFilteredShoutouts = shoutouts.filter((shoutout) => {
          let isUserInShoutout = false;
          shoutout.recipients.forEach(recipient => {
            if (ids.indexOf(recipient._id) !== -1) isUserInShoutout = true;
          });
          return isUserInShoutout;
        });
      }
      return { ...state, users, timeFrame, filteredShoutouts: userFilteredShoutouts, showWinnerButton };
    }

    case show_codecommit_stats:
      return { ...state, showStats: action.payload };

    case get_tvmode_queue: {
      let queue = state.filteredShoutouts.map((shoutout, i) => {
        return (
          <TVSlide
            key={i}
            index={i}
            shoutout={shoutout}
          />
        );
      });
      if (state.showStats) queue.unshift(<TVIntegrationSlide timeFrame={state.timeFrame} key="integration"/>);
      return { ...state, queue };
    }

    case update_queue: {
      let newQueue = [];
      if (action.payload === 'backwards') {
        newQueue = state.queue.splice(0, state.queue.length - 1);
        newQueue.unshift(state.queue[state.queue.length - 1]);
      } else if (action.payload === 'forwards') {
        newQueue = state.queue.splice(1, state.queue.length - 1);
        newQueue.push(state.queue[0]);
      }
      return { ...state, queue: newQueue };
    }

    case pick_winner: {
      return { ...state, newShoutouts: [ ...state.newShoutouts, action.payload ], showWinnerButton: false };
    }

    case add_to_alert_queue: {
      return { ...state, alert: [ ...state.alert, action.payload ] };
    }

    case add_to_new_shoutouts: {
      return { ...state, newShoutouts: [ ...state.newShoutouts, action.payload.shoutout ], queue: [ ...state.queue, action.payload.shoutoutSlide ] };
    }

    case pop_from_new_shoutouts: {
      let newShoutouts = state.newShoutouts.splice(1, state.newShoutouts.length - 1);
      return { ...state, newShoutouts };
    }

    case pop_from_alert_queue:
      return { ...state, alert: state.alert.splice(1, state.alert.length - 1) };

    case leave_pick_winner_mode:
      return { ...state, showWinnerButton: false };
    case time_frame_tv_filter_toggled:
      return { ...state, timeFrameSelected: !state.timeFrameSelected };

    case recipient_tv_filter_toggled:
      return { ...state, recipientSelected: !state.recipientSelected };

    case modal_next: {
      const { modalStep, timeFrameSelected, recipientSelected } = state;
      let newModalStep = 0;
      if (modalStep === 0) {
        if (timeFrameSelected) newModalStep = 1;
        else if (recipientSelected) newModalStep = 2;
        else newModalStep = 3;
      } else if (modalStep === 1) {
        if (recipientSelected) newModalStep = 2;
        else newModalStep = 3;
      } else if (modalStep === 2) {
        newModalStep = 3;
      }
      return { ...state, modalStep: newModalStep };
    }

    case modal_back: {
      const { modalStep, timeFrameSelected, recipientSelected } = state;
      let newModalStep = 0;
      if (modalStep === 3) {
        if (recipientSelected) newModalStep = 2;
        else if (timeFrameSelected) newModalStep = 1;
        else newModalStep = 0;
      } else if (modalStep === 2) {
        if (timeFrameSelected) newModalStep = 1;
        else newModalStep = 0;
      } else if (modalStep === 1){
        newModalStep = 0;
      }
      return { ...state, modalStep: newModalStep };
    }

    case set_time_frame_range: {
      return { ...state, timeFrame: action.payload };
    }

    case set_selected_users: {
      return { ...state, users: action.payload };
    }

    case code_input_changed:
      return { ...state, codeText: action.payload };

    case display_type_changed:
      return { ...state, displayType: action.payload };

    case clear_modal:
      return { ...INITIAL_STATE };

    case connect_to_tv:
      return { ...state, connection: action.payload };

    default: return state;
  }
};




// WEBPACK FOOTER //
// ./src/reducers/TVModeReducer.js